import type { ButtonHTMLAttributes, JSX } from "react";

export function PrimaryButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  return (
    <button
      {...props}
      className={[
        "rounded-lg bg-brand px-4 py-2 text-sm font-medium text-brand-ink",
        "hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
        className ?? "",
      ].join(" ")}
    />
  );
}
